import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

export default function MiniGraph({ data, color }) {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart
        data={data}
        margin={{ top: 0, right: 0, left: 0, bottom: 5 }}
      >
        <XAxis
          dataKey="time"
          tick={{ fontSize: 10 }}
          label={{
            value: "Time (HH:mm)",
            position: "insideBottom",
            offset: -5,
            fontSize: 10,
          }}
        />

        <YAxis
          tick={{ fontSize: 10 }}
          label={{
            value: "Level (m)",
            angle: -90,
            position: "insideLeft",
            offset: 10,       // push slightly below the axis
            dy: 20,            // vertical adjust
            fontSize: 10,
          }}
        />

        <Tooltip formatter={(value) => `${value} m`} />

        <Line
          type="linear"
          dataKey="value"
          stroke={color}
          strokeWidth={2}
          dot={false}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}
